export default __webpack_public_path__ + "static/media/NoPreviewAvailable.1d605547.jpg";